import React from 'react'
import PropTypes from 'prop-types'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  useMediaQuery
} from '@material-ui/core'
import { MODAL_STYLES } from 'asterX-UI/theme.constant'
import ModalTitle from 'asterX-UI/Modals/ModalTitle'
import { useInfoModalStyles } from 'asterX-UI/Modals/modals.styles'
import { AlertOctagonIcon } from 'asterX-UI/Icons'
import { AlertFutureIcon } from 'asterX-UI/Icons/AlertFutureIcon'
import InfoOctagonIcon from 'asterX-UI/Icons/InfoOctagonIcon'

const InfoModal = ({
  open,
  onClose,
  variant = '',
  title = '',
  btnText = 'OK',
  iconComponent = null,
  isButtonHidden,
  ...other
}) => {
  const classes = useInfoModalStyles({ variant })
  const isMobile = useMediaQuery(theme => theme.breakpoints.down('lg'))

  const getIconComponent = () => {
    const [info, warning, error, success] = MODAL_STYLES.variant
    if (variant === info) {
      return <InfoOctagonIcon />
    }
    if (variant === warning) {
      return <AlertOctagonIcon />
    }
    if (variant === error) {
      return <AlertFutureIcon />
    }
    if (variant === success) {
      return <AlertOctagonIcon />
    }
    return <AlertOctagonIcon />
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={isMobile ? 'xs' : 'sm'}
      classes={{ paper: classes.paper }}
      fullWidth
      {...other}
    >
      <ModalTitle
        onClose={onClose}
        iconComponent={iconComponent || getIconComponent()}
        style={{color: '#101828'}}
      >
        {title}
      </ModalTitle>
      <DialogContent>{other.children}</DialogContent>
      {
        isButtonHidden ? '' :
          <DialogActions>
            <Button variant={'outlined'} fullWidth onClick={onClose}>
              {btnText}
            </Button>
          </DialogActions>
      }
    </Dialog>
  )
}
export default InfoModal
InfoModal.propTypes = {
  title: PropTypes.string,
  open: PropTypes.bool,
  onClose: PropTypes.func,
  variant: PropTypes.oneOf(MODAL_STYLES.variant),
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.string])
}
